import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import * as _ from 'lodash';

// Gutwin Shared Library
import { DialogService, ModalService } from 'gutwin-shared';

// Models
import { FindingType } from '../../../shared/models/finding-type.model';

// Components
import { AddFindingTypeComponent } from './add-finding-type/add-finding-type.component';

// Services
import { FindingService } from '../../../shared/services/finding.service';

@Component({
  selector: 'gw-finding-types',
  templateUrl: './finding-types.component.html',
  styleUrls: ['./finding-types.component.scss']
})
export class FindingTypesComponent implements OnInit {
  @ViewChild('addFindingType') addFindingType: AddFindingTypeComponent;
  findingTypes: Array<FindingType>;
  translation = {
    notify: {
      error: {
        connectionTitle: '',
        removeFindingType: ''
      },
      success: {
        removeFindingTypeTitle: '',
        removeFindingTypeText: ''
      }
    },
    removeDialog: {
      header: '',
      content: '',
      cancel: '',
      confirm: ''
    }
  };

  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private notificationsService: NotificationsService,
    private modalService: ModalService,
    private findingService: FindingService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.findingTypes = this.route.snapshot.data['findingTypes'];
    this.fetchTranslation();
  }

  appendFindingType(findingType: FindingType): void {
    this.findingTypes.push(findingType);
  }

  updateFindingType(findingType: FindingType): void {
    this.spliceFindingType(findingType);
    this.appendFindingType(findingType);
  }

  spliceFindingType(findingType: FindingType): void {
    const index = _.findIndex(this.findingTypes, { id: findingType.id });
    if (~index) {
      this.findingTypes.splice(index, 1);
    }
  }

  saveFindingType(): void {
    this.addFindingType
      .submitAddFindingTypeForm()
      .then(findingTypeResponse => {
        if (findingTypeResponse.status === 'create') {
          this.appendFindingType(findingTypeResponse.findingType);
        } else if (findingTypeResponse.status === 'update') {
          this.updateFindingType(findingTypeResponse.findingType);
        }
        this.modalService.close('findingTypeModal');
      })
      .catch(error => {});
  }

  showUpdateFindingTypeModal(findingType: FindingType): void {
    this.modalService.open('findingTypeModal', findingType);
  }

  showRemoveModal(findingType: FindingType): void {
    this.dialogService
      .confirm(
        this.translation.removeDialog.header,
        this.translation.removeDialog.content,
        this.translation.removeDialog.cancel,
        this.translation.removeDialog.confirm
      )
      .then(() => {
        this.removeFindingType(findingType);
      })
      .catch(() => {});
  }

  removeFindingType(findingType: FindingType): void {
    this.findingService
      .archiveFindingType(findingType)
      .then(() => {
        this.spliceFindingType(findingType);
        this.notificationsService.success(
          this.translation.notify.success.removeFindingTypeTitle,
          this.translation.notify.success.removeFindingTypeText
        );
      })
      .catch(error => {
        this.notificationsService.error(
          this.translation.notify.error.connectionTitle,
          this.translation.notify.error.removeFindingType
        );
      });
  }

  async fetchTranslation(): Promise<void> {
    const translation = await this.translateService
      .get([
        'GLOBAL.ERROR.CONNECTION',
        'GLOBAL.ACTION.CANCEL',
        'GLOBAL.ACTION.REMOVE',
        'ADMIN_SETTINGS.FINDING_TYPES.ERROR.REMOVE_FINDING_TYPE',
        'ADMIN_SETTINGS.FINDING_TYPES.SUCCESS.REMOVE_FINDING_TYPE_TITLE',
        'ADMIN_SETTINGS.FINDING_TYPES.SUCCESS.REMOVE_FINDING_TYPE_TEXT',
        'ADMIN_SETTINGS.FINDING_TYPES.REMOVE_MODAL.HEADER',
        'ADMIN_SETTINGS.FINDING_TYPES.REMOVE_MODAL.CONTENT'
      ])
      .toPromise();
    this.translation.notify.error.connectionTitle = translation['GLOBAL.ERROR.CONNECTION'];
    this.translation.notify.error.removeFindingType =
      translation['ADMIN_SETTINGS.FINDING_TYPES.ERROR.REMOVE_FINDING_TYPE'];
    this.translation.notify.success.removeFindingTypeTitle =
      translation['ADMIN_SETTINGS.FINDING_TYPES.SUCCESS.REMOVE_FINDING_TYPE_TITLE'];
    this.translation.notify.success.removeFindingTypeText =
      translation['ADMIN_SETTINGS.FINDING_TYPES.SUCCESS.REMOVE_FINDING_TYPE_TEXT'];
    this.translation.removeDialog.header = translation['ADMIN_SETTINGS.FINDING_TYPES.REMOVE_MODAL.HEADER'];
    this.translation.removeDialog.content = translation['ADMIN_SETTINGS.FINDING_TYPES.REMOVE_MODAL.CONTENT'];
    this.translation.removeDialog.cancel = translation['GLOBAL.ACTION.CANCEL'];
    this.translation.removeDialog.confirm = translation['GLOBAL.ACTION.REMOVE'];
  }
}
